/* ==========================================================================
 * contact-quote-form.js — /pages/contact (refonte)
 * Two-step flow:
 *   - "amenagement" | "question" → contact form → success
 *   - "revente"                  → redirect to /pages/revendre-mon-mobilier
 *
 * One FormSubmit POST at final submission (mirrors simulator.js pattern).
 * Loaded as: <script src="{{ 'contact-quote-form.js' | asset_url }}" defer>
 * No bundlers, vanilla only, idempotent.
 * ========================================================================== */

(function () {
  'use strict';

  var FS_ENDPOINT = 'https://formsubmit.co/ajax/';
  var BOUND_FLAG  = '__cqfFormBound';
  var DNT = (typeof navigator !== 'undefined' && navigator.doNotTrack === '1');

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_RE = /^(\+33|0)[1-9](\d{8})$/;

  var FALLBACK_I18N = {
    'cqf.error.required':  'Ce champ est requis.',
    'cqf.error.email':     'Adresse e-mail invalide.',
    'cqf.error.phone':     'Numéro de téléphone invalide (ex. 06 12 34 56 78).',
    'cqf.error.consent':   'Vous devez accepter pour continuer.',
    'cqf.error.intent':    'Choisissez une option pour continuer.',
    'cqf.error.network':   'Une erreur réseau est survenue. Merci de réessayer.',
    'cqf.error.invalid_data': 'Certaines informations sont invalides. Merci de vérifier le formulaire.',
    'cqf.legal.consent_text': "J'accepte d'être recontacté(e) par Redesk.",
    'cqf.step_contact.title_amenagement':    'Parlons de votre projet',
    'cqf.step_contact.title_question':       'Votre message',
    'cqf.step_contact.subtitle_amenagement': 'Décrivez votre besoin en quelques mots — notre équipe revient vers vous sous 48h.',
    'cqf.step_contact.subtitle_question':    'Expliquez votre demande — nous vous répondrons sous 24h ouvrées.',
    'cqf.step_contact.message_label_amenagement':       'Décrivez votre projet',
    'cqf.step_contact.message_placeholder_amenagement': 'Type de bureaux, surface, nombre de postes, délai souhaité…',
    'cqf.step_contact.message_label_question':          'Votre message',
    'cqf.step_contact.message_placeholder_question':    'Décrivez votre demande en quelques lignes.'
  };

  var STEP_INTENT  = 'intent';
  var STEP_CONTACT = 'contact';
  var STEP_REVENTE = 'revente';
  var STEP_SUCCESS = 'success';

  function initAll() {
    var nodes = document.querySelectorAll('[data-quote-form]');
    for (var i = 0; i < nodes.length; i++) {
      var root = nodes[i];
      if (root[BOUND_FLAG]) continue;
      root[BOUND_FLAG] = true;
      try { new ContactQuoteForm(root); }
      catch (e) { console.error('[contact-quote-form] init failed', e); }
    }
  }

  function ContactQuoteForm(root) {
    this.root        = root;
    this.formsubmitEmail = root.getAttribute('data-formsubmit-email') || '';
    this.successRedirect = root.getAttribute('data-success-redirect') || '';
    this.reventeUrl      = root.getAttribute('data-revente-url') || '/pages/revendre-mon-mobilier';
    this.source          = root.getAttribute('data-quote-source') || 'Page contact Redesk';
    // PDP : l'intention est connue (devis sur ce produit), l'étape 1 est sautée.
    this.intentPreset    = root.getAttribute('data-quote-intent-preset') || '';

    this.steps = {};
    this.steps[STEP_INTENT]  = root.querySelector('[data-quote-step="intent"]');
    this.steps[STEP_CONTACT] = root.querySelector('[data-quote-step="contact"]');
    this.steps[STEP_REVENTE] = root.querySelector('[data-quote-step="revente"]');
    this.steps[STEP_SUCCESS] = root.querySelector('[data-quote-step="success"]');

    this.errorBanner = root.querySelector('[data-quote-error]');
    this.stepperEl   = root.querySelector('[data-quote-stepper]');
    this.stepperLine = root.querySelector('[data-quote-stepper-line]');
    this.stepperSr   = root.querySelector('[data-quote-stepper-sr]');

    this.i18n    = readI18n();
    this.state   = STEP_INTENT;
    this.intent  = null;
    this.payload = {};

    this.previewMode = !this.formsubmitEmail;
    if (this.previewMode) {
      console.warn('[contact-quote-form] preview mode — FormSubmit email missing, submissions will fake-resolve.');
    }

    this.bindIntent();
    this.bindContactForm();
    this.updateStepper();
    if (this.intentPreset) this.applyIntentPreset();
  }

  // Démarre directement sur l'étape « contact » avec une intention imposée.
  // On ne passe pas par goTo() : il déplacerait le focus au chargement de la page.
  ContactQuoteForm.prototype.applyIntentPreset = function () {
    this.intent = this.intentPreset;
    this.payload.redesk_intent = this.intentPreset;
    this.adaptContactStep();
    if (this.steps[STEP_INTENT]) this.steps[STEP_INTENT].setAttribute('hidden', '');
    if (this.steps[STEP_CONTACT]) this.steps[STEP_CONTACT].removeAttribute('hidden');
    this.state = STEP_CONTACT;
    this.updateStepper();
  };

  // ---- Intent (step 1) ---------------------------------------------------
  ContactQuoteForm.prototype.bindIntent = function () {
    var self = this;
    var step = this.steps[STEP_INTENT];
    if (!step) return;
    var cards = step.querySelectorAll('[data-quote-intent]');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        card.addEventListener('click', function () {
          self.handleIntentSelect(card.getAttribute('data-quote-intent'), card);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
        });
      })(cards[i]);
    }
  };

  ContactQuoteForm.prototype.handleIntentSelect = function (intent, cardEl) {
    var step = this.steps[STEP_INTENT];
    if (!step || !intent) return;

    var cards = step.querySelectorAll('[data-quote-intent]');
    for (var i = 0; i < cards.length; i++) {
      cards[i].setAttribute('aria-pressed', cards[i] === cardEl ? 'true' : 'false');
    }

    this.intent = intent;
    this.payload.redesk_intent = intent;
    this.fireEvent('contact_quote_intent_selected', { intent: intent });

    if (intent === 'revente') {
      this.goTo(STEP_REVENTE);
      var url = this.reventeUrl;
      setTimeout(function () { try { window.location.assign(url); } catch (_) {} }, 900);
      return;
    }

    this.adaptContactStep();
    this.goTo(STEP_CONTACT);
  };

  // Update contact step heading and message field to match the selected intent.
  ContactQuoteForm.prototype.adaptContactStep = function () {
    var step = this.steps[STEP_CONTACT];
    if (!step) return;
    var isAmenagement = this.intent === 'amenagement';

    var titleEl    = step.querySelector('[data-quote-contact-title]');
    var subtitleEl = step.querySelector('[data-quote-contact-subtitle]');
    var msgLabel   = step.querySelector('[data-quote-message-label]');
    var msgInput   = step.querySelector('[data-quote-message-input]');

    if (titleEl) {
      titleEl.textContent = this.t(isAmenagement ? 'cqf.step_contact.title_amenagement' : 'cqf.step_contact.title_question');
    }
    if (subtitleEl) {
      subtitleEl.textContent = this.t(isAmenagement ? 'cqf.step_contact.subtitle_amenagement' : 'cqf.step_contact.subtitle_question');
    }
    if (msgLabel) {
      var span = msgLabel.querySelector('span');
      msgLabel.textContent = this.t(isAmenagement ? 'cqf.step_contact.message_label_amenagement' : 'cqf.step_contact.message_label_question');
      if (span) msgLabel.appendChild(span);
    }
    if (msgInput) {
      msgInput.placeholder = this.t(isAmenagement ? 'cqf.step_contact.message_placeholder_amenagement' : 'cqf.step_contact.message_placeholder_question');
    }
  };

  // ---- Contact form (step 2 — only form) ---------------------------------
  ContactQuoteForm.prototype.bindContactForm = function () {
    var self = this;
    var step = this.steps[STEP_CONTACT];
    if (!step) return;
    var form = step.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.handleFinalSubmit(form);
    });
    // ponytail: un seul event au premier contact avec le formulaire. Sans lui on sait
    // combien envoient, jamais combien ont essaye, et on ne peut pas distinguer
    // « l'offre n'interesse pas » de « le formulaire bloque ».
    var started = false;
    function markStarted() {
      if (started) return;
      started = true;
      self.fireEvent('contact_quote_started', {});
    }
    form.addEventListener('input',  function (e) { markStarted(); self.clearFieldError(e.target); });
    form.addEventListener('change', function (e) { markStarted(); self.clearFieldError(e.target); });

    var backBtn = form.querySelector('[data-quote-back]');
    if (backBtn) backBtn.addEventListener('click', function () { self.goTo(STEP_INTENT); });
  };

  ContactQuoteForm.prototype.handleFinalSubmit = function (formEl) {
    var self = this;
    if (this.state === 'submitting') return;

    var values = collectFormValues(formEl);
    var errors = validateContact(formEl, values);
    if (Object.keys(errors).length) {
      this.applyFieldErrors(formEl, errors);
      return;
    }

    var keys = Object.keys(values);
    for (var i = 0; i < keys.length; i++) this.payload[keys[i]] = values[keys[i]];

    this.hideError();
    this.state = 'submitting';
    setSubmitting(formEl, true);

    var fsPayload = buildFormSubmitPayload({
      fields: this.payload,
      intent: this.intent,
      source: this.source,
      consentText: this.t('cqf.legal.consent_text')
    });

    submitMaybePreview(this, fsPayload)
      .then(function () {
        if (window.RedeskDL && typeof window.RedeskDL.pushFormSubmit === 'function') {
          window.RedeskDL.pushFormSubmit({
            form_id: 'contact_quote',
            intent: self.intent,
            values: self.payload,
            consent: !!self.payload.consent
          });
        }
        self.fireEvent('contact_quote_submitted', {
          quantite: self.payload.quantite || '',
          produit: self.payload.produit || '',
          consent: !!self.payload.consent
        });
        if (self.successRedirect) {
          try { window.location.assign(self.successRedirect); return; } catch (_) {}
        }
        self.goTo(STEP_SUCCESS);
      })
      .catch(function (err) {
        // ponytail: un formulaire casse doit etre visible dans PostHog, pas seulement en console.
        self.fireEvent('contact_quote_error', { message: (err && err.message) || 'inconnu' });
        handleSubmitError(self, err);
      })
      .then(function () {
        if (self.state === 'submitting') self.state = STEP_CONTACT;
        setSubmitting(formEl, false);
      });
  };

  // ---- State transitions -------------------------------------------------
  ContactQuoteForm.prototype.goTo = function (target) {
    var keys = Object.keys(this.steps);
    for (var i = 0; i < keys.length; i++) {
      var el = this.steps[keys[i]];
      if (!el) continue;
      if (keys[i] === target) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    }
    this.state = target;
    this.updateStepper();

    var newStep = this.steps[target];
    if (newStep) {
      var focusTarget = newStep.querySelector('h2[tabindex], [data-quote-focus], input, select, textarea, button');
      if (focusTarget) {
        try { focusTarget.focus({ preventScroll: false }); } catch (_) { try { focusTarget.focus(); } catch (__) {} }
      }
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        try { this.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) {}
      }
    }
  };

  ContactQuoteForm.prototype.updateStepper = function () {
    if (!this.stepperEl) return;
    // 0 = intent active, 1 = contact/success active
    var index = (this.state === STEP_INTENT) ? 0 : 1;

    var steps = this.stepperEl.querySelectorAll('[data-quote-stepper-step]');
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('cqf-stepper__step--active', 'cqf-stepper__step--done');
      if (i < index) steps[i].classList.add('cqf-stepper__step--done');
      else if (i === index) steps[i].classList.add('cqf-stepper__step--active');
    }
    if (this.stepperLine) {
      var maxSegments = Math.max(1, steps.length - 1);
      var pct = Math.min(1, index / maxSegments) * 100;
      this.stepperLine.style.width = pct + '%';
    }
    if (this.stepperSr) {
      this.stepperSr.textContent = this.t('cqf.stepper.sr_step_' + (index + 1)) || ('Étape ' + (index + 1));
    }
  };

  ContactQuoteForm.prototype.showError = function (i18nKey) {
    if (!this.errorBanner) return;
    this.errorBanner.textContent = this.t(i18nKey || 'cqf.error.network');
    this.errorBanner.removeAttribute('hidden');
  };

  ContactQuoteForm.prototype.hideError = function () {
    if (this.errorBanner) this.errorBanner.setAttribute('hidden', '');
  };

  // ---- Validation --------------------------------------------------------
  function validateContact(formEl, values) {
    var errors = {};
    var fields = formEl.querySelectorAll('[required]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (!f.name) continue;
      var bare = f.name.replace(/\[\]$/, '');
      if (errors[bare]) continue;
      var v = values[bare];
      var empty = (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0));
      if (empty) errors[bare] = 'cqf.error.required';
    }
    if (values.email && !EMAIL_RE.test(values.email)) {
      errors.email = 'cqf.error.email';
    }
    if (values.phone) {
      var stripped = String(values.phone).replace(/[\s.\-]/g, '');
      if (!PHONE_RE.test(stripped)) errors.phone = 'cqf.error.phone';
    }
    var consentEl = formEl.querySelector('input[name="consent"]');
    if (consentEl && consentEl.required && !consentEl.checked) {
      errors.consent = 'cqf.error.consent';
    }
    return errors;
  }

  ContactQuoteForm.prototype.applyFieldErrors = function (formEl, errors) {
    var firstInvalid = null;
    var keys = Object.keys(errors);
    for (var i = 0; i < keys.length; i++) {
      var name    = keys[i];
      var key     = errors[name];
      var wrapper = formEl.querySelector('.cqf-field[data-field="' + name + '"]');
      var msgEl   = wrapper && wrapper.querySelector('.cqf-field__error');
      var inputEl = formEl.querySelector('[name="' + name + '"], [name="' + name + '[]"]');
      if (wrapper)  wrapper.classList.add('is-invalid');
      if (msgEl)    msgEl.textContent = this.t(key);
      if (inputEl) {
        inputEl.setAttribute('aria-invalid', 'true');
        if (!firstInvalid) firstInvalid = inputEl;
      }
    }
    if (firstInvalid) try { firstInvalid.focus(); } catch (_) {}
  };

  ContactQuoteForm.prototype.clearFieldError = function (target) {
    if (!target || !target.name) return;
    var name    = target.name.replace(/\[\]$/, '');
    var wrapper = target.closest && target.closest('.cqf-field[data-field="' + name + '"]');
    if (wrapper) {
      wrapper.classList.remove('is-invalid');
      var msgEl = wrapper.querySelector('.cqf-field__error');
      if (msgEl) msgEl.textContent = '';
    }
    target.removeAttribute('aria-invalid');
  };

  // ---- FormSubmit POST ---------------------------------------------------
  function submitMaybePreview(instance, payload) {
    if (instance.previewMode) {
      console.info('[contact-quote-form] preview submit (no FormSubmit call)', payload);
      return new Promise(function (resolve) { setTimeout(function () { resolve({ preview: true }); }, 250); });
    }
    var url = FS_ENDPOINT + encodeURIComponent(instance.formsubmitEmail);
    return fetchOnceWithRetry(url, payload, 1);
  }

  function fetchOnceWithRetry(url, payload, retriesLeft) {
    return doFetch(url, payload).catch(function (err) {
      var status = err && err.status;
      var transient = !status || status === 429 || (status >= 500 && status <= 599) || err.networkError;
      if (transient && retriesLeft > 0) {
        return wait(1000).then(function () { return fetchOnceWithRetry(url, payload, retriesLeft - 1); });
      }
      throw err;
    });
  }

  function doFetch(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok) return res.json().catch(function () { return {}; });
      return res.json().catch(function () { return null; }).then(function (body) {
        var e = new Error('FormSubmit ' + res.status);
        e.status = res.status;
        e.body = body;
        throw e;
      });
    }, function (netErr) {
      var e = new Error('Network error');
      e.networkError = true;
      e.cause = netErr;
      throw e;
    });
  }

  function handleSubmitError(self, err) {
    console.error('[contact-quote-form] FormSubmit failed', err);
    if (err && err.status && err.status >= 400 && err.status < 500) {
      self.showError('cqf.error.invalid_data');
      return;
    }
    self.showError('cqf.error.network');
  }

  function buildFormSubmitPayload(opts) {
    var fields = opts.fields || {};
    var intent = opts.intent || '';
    var firstname = fields.firstname || '';
    var lastname  = fields.lastname  || '';
    var fullName  = (firstname + ' ' + lastname).trim();
    var subjectIntentLabel = intent === 'amenagement'
      ? 'Aménagement'
      : (intent === 'question' ? 'Question'
      : (intent === 'devis_produit' ? 'Devis produit' : (intent || 'Contact')));
    var subject = '[' + subjectIntentLabel + '] Nouveau contact — ' + (fullName || (fields.email || ''));
    // Devis depuis une fiche : le produit demandé passe dans l'objet, c'est lui
    // qui rend l'e-mail actionnable sans ouvrir le lien.
    if (fields.produit) {
      subject = '[' + subjectIntentLabel + '] ' + fields.produit + ' : ' + (fullName || (fields.email || ''));
    }

    var payload = {
      _subject:  subject,
      _replyto:  fields.email || '',
      _template: 'box',
      _captcha:  'false',
      intent:        intent,
      firstname:     firstname,
      lastname:      lastname,
      email:         fields.email || '',
      phone:         fields.phone || '',
      message:       fields.redesk_message || '',
      consent:       fields.consent ? 'oui' : 'non',
      consent_text:  opts.consentText || '',
      page_url:      (typeof location !== 'undefined') ? location.href : '',
      source:        opts.source || 'Page contact Redesk'
    };
    if (fields.produit) {
      payload.produit     = fields.produit;
      payload.produit_url = fields.produit_url || '';
    }
    // Quantité demandée (bande PDP cabines) : c'est ce qui distingue un lead
    // « 1 cabine » d'un lead volume, donc il doit apparaître dans l'e-mail.
    if (fields.quantite) {
      payload.quantite = fields.quantite;
    }
    return payload;
  }

  function collectFormValues(formEl) {
    var out = {};
    if (!formEl) return out;
    var fd = new FormData(formEl);
    fd.forEach(function (val, key) {
      if (key.endsWith('[]')) {
        var bare = key.slice(0, -2);
        if (!Array.isArray(out[bare])) out[bare] = [];
        out[bare].push(val);
      } else {
        out[key] = val;
      }
    });
    // Case à cocher : c'est .checked qui compte, pas la valeur. Champ caché
    // (bande PDP, mention affichée sans case) : on garde la valeur postée.
    var consent = formEl.querySelector('input[name="consent"]');
    if (consent && consent.type === 'checkbox') out.consent = !!consent.checked;
    return out;
  }

  // ---- Events ------------------------------------------------------------
  ContactQuoteForm.prototype.fireEvent = function (name, extra) {
    var detail = { event: name, timestamp: new Date().toISOString(), page: location.pathname };
    detail.source = this.source;
    detail.intent = this.intent || this.intentPreset || '';
    if (extra) {
      var keys = Object.keys(extra);
      for (var i = 0; i < keys.length; i++) detail[keys[i]] = extra[keys[i]];
    }
    if (!DNT) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      // ponytail: meme signal vers PostHog. Sans ca les demandes de devis, qui sont
      // la vraie conversion B2B, n'existent nulle part cote produit analytics.
      // Jamais de PII ici : nom, email et telephone restent dans le dataLayer et le mail.
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture(name, detail);
        }
      } catch (_) {}
    }
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (_) {}
  };

  // ---- i18n + helpers ----------------------------------------------------
  ContactQuoteForm.prototype.t = function (key) {
    if (this.i18n && Object.prototype.hasOwnProperty.call(this.i18n, key)) return this.i18n[key];
    if (Object.prototype.hasOwnProperty.call(FALLBACK_I18N, key)) return FALLBACK_I18N[key];
    return '';
  };

  function readI18n() {
    var node = document.getElementById('contact-quote-i18n');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); }
    catch (e) { console.warn('[contact-quote-form] failed to parse i18n', e); return null; }
  }

  function setSubmitting(formEl, on) {
    if (!formEl) return;
    var btn = formEl.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = !!on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    formEl.setAttribute('data-submitting', on ? 'true' : 'false');
  }

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Boot — placed at the bottom so all prototype methods are defined before
  // initAll() runs. With `defer` the script executes after DOM parse, so
  // readyState is typically 'interactive' here and initAll runs synchronously.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
